<template>
  <div class="foot">
    <div class="box">
      <div class="boxLeft">
        <img class="footlogo" src="../assets/Ignitemedialogo3.png" alt="" />
        <div class="othersLogo">
          <div class="othersLogo_left">
            <img class="othersLogo_left_1" src="../assets/GDPR.png" alt="" />
            <img class="othersLogo_left_2" src="../assets/Coppa.png" alt="" />
            <img class="othersLogo_left_3" src="../assets/14117.png" alt="" />
          </div>
          <div class="othersLogo_right">
            <img class="othersLogo_right_1" src="../assets/IAB_TCF.png" alt="" />
            <img class="othersLogo_right_2" src="../assets/DPF_logo.png" alt="" />
          </div>

        </div>
        <div class="boxleftText">
          Copyrights @ 2025 Ignite Media HK Ltd All rights reserved
        </div>
      </div>
      <div class="boxRight">
        <div class="boxRight_item">
          <div class="boxRight_dw">
            <img class="dw" src="../assets/_20230208111655.png" alt="" />
            <span>HongKong </span>
          </div>
          <div class="boxRight_tex">
            Room 603E,6/F,Hang Pont Commercial Building,31 Tonkin Street, Cheung
            Sha Wan,Kowloon,Hongkong
          </div>
        </div>
        <div class="boxRight_item">
          <div class="boxRight_dw">
            <img class="dw" src="../assets/_20230208111655.png" alt="" />
            <span>Singapore </span>
          </div>
          <div class="boxRight_tex">
            10 ANSON ROAD #27 - 18 INTERNATIONAL PLAZA SINGAPORE (079903)
          </div>
        </div>
        <div style="width: 190px;margin-top: 8px;">
          <div>
            <span>Legal </span>
          </div>
          <div style="font-size: 14px;margin-top: 18px;">
            <router-link to="/Policy" class="Navitem" style="color:white">Privacy Policy</router-link><br />
            <router-link to="/PolicyDPF" class="Navitem" style="color:white">Privacy Policy - DPF</router-link><br />
            <router-link to="/lic" class="Navitem" style="color:white">Legitimate Interest Claim</router-link>
          </div>
        </div>
        <div class="boxRight_item boxRight_item03">
          <div class="boxRight_dw">
            <img class="dw" src="../assets/_20230208111655.png" alt="" />
            <span>Indonesia </span>
          </div>
          <div class="boxRight_tex">
            23F,Sahid Sudirman Center, Jl.Jend. Sudirman No.Kav.13-15,Karet
            Tengsin,Jakarta Pusat, Indonesia
          </div>
        </div>
        <div class="boxRight_item">
          <div class="boxRight_dw">
            <img class="dw" src="../assets/_20230208111655.png" alt="" />
            <span>USA </span>
          </div>
          <div class="boxRight_tex">
            17595 HARVARD AVE, STE C-992,IRVINE, CA 92614
          </div>
        </div>
        <div style="width: 150px;">
          <div style="font-size: 14px;">
            <span>business@ignitemediatech.com </span>
          </div>
          <div style="font-size: 14px;">
            <span>+62 (021) 39506895</span>
          </div>
          <div class="follow">
            <p>Follow us</p>
            <a href="https://sg.linkedin.com/company/ignite-media-tech" target="_blank">
              <img class="linkedin" src="../assets/linkedin.png" alt="" />
            </a>
            <a href="https://www.instagram.com/liftymedia.id" target="_blank">
              <img class="Instagram" src="../assets/Instagram.png" alt="" />
            </a>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "foot",
  props: {},
};
</script>


<style scoped>
body {
  line-height: 1.6;
}

img {
  object-fit: contain;
  background-size: contain;
}

.foot {
  width: 100%;
  max-width: 100%;
  min-width: 1370px;
  color: #ffffff;
  background-color: #3c065e;

}

.box {
  width: 1370px;
  margin: auto;
  display: flex;
  min-height: 362px;
}

.footlogo {
  width: 275px;
  /* height: 87px; */
  margin-top: 5px;
}

.othersLogo {
  display: flex;
  align-items: center;
  padding-left: 30px;
}

.othersLogo_left {
  width: 230px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-right: 70px;
}

.othersLogo_left_1 {
  width: 90px;
  height: 115px;
  margin-bottom: 10px;
  object-fit: fill;
}

.othersLogo_left_2 {
  height: 115px;
  margin-bottom: 10px;
}

.othersLogo_left_3 {
  width: 215px;
  height: 84px;
  object-fit: fill;
}

.othersLogo_right {
  width: 193px;
  margin-right: 70px;
}

.othersLogo_right_1 {
  width: 193px;
  margin-bottom: 10px;
}

.othersLogo_right_2 {
  margin-top: 10px;
  width: 193px;
}


.follow p {
  font-size: 20px;
  margin-top: 15px;
  font-weight: 400;
  line-height: 1.1;
}

.follow .linkedin {
  height: 50px;
  margin-top: 9px;
  /* margin-left: 50px; */
}

.follow .Instagram {
  height: 50px;
  margin-top: 9px;
}

.boxleftText {
  font-size: 14px;
  margin-top: 10px;
  /* margin-bottom: 5px; */
  margin-left: 23px;
}

.boxRight {
  /* width: 473px; */
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  margin-top: 48px;
  margin-left: 50px;
}

.boxRight_dw {
  display: flex;
  align-items: center;
  font-size: 20px;
  margin-bottom: 6px;
  margin-left: 15px;
}

.boxRight_dw .dw {
  width: 48px;
  height: 48px;
  margin-right: 5px;
}

.boxRight_item {
  width: 200px;
  margin-right: 30px;
  margin-bottom: 9px;
}

.boxRight_item03 {
  margin-bottom: 18px;

}

.boxRight_item04 {
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 17px;
  width: 245px;
  text-align: left !important;
  margin-bottom: 18px;
}

.boxRight_t {
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 2px;

}

.u-svg-content {
  margin-right: 15px;
}

.boxRight_tex {
  text-align: center;
  font-size: 14px;
}

.tips {
  color: #ffffff;
  background-color: #333333;
  display: flex;
  align-content: center;
  justify-content: center;
  padding: 1em;
  font-size: 16px;
  line-height: 1.6;

}

.u-link,
.u-text {
  padding-top: 20px;
  padding-bottom: 20px;
}

.u-link {
  color: #adcce9;
}
</style>